const pruefenDarstellungIstMobil = (breakpointDesktop) => {
    return window.innerWidth < breakpointDesktop;
};

export default { pruefenDarstellungIstMobil }